import { FC } from 'react';
import { Box, Modal } from '@mui/material';

import FullAccessBanner from '../FullAccessBanner';
import { MODAL_ABOVE_FULL_SCREEN_Z } from '../../constants/modalZIndex';
import { PremiumFeature } from '../premiumFeatures';
import styles from './FullAccessModal.module.scss';

interface FullAccessModalProps {
  open: boolean;
  feature?: PremiumFeature;
  onClose: () => void;
}

const FullAccessModal: FC<FullAccessModalProps> = ({ open, feature, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="full-access-modal"
      sx={{
        zIndex: MODAL_ABOVE_FULL_SCREEN_Z,
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(34, 43, 58, 0.2)',
        },
      }}
    >
      <Box className={styles.modalContent}>
        <FullAccessBanner
          variant="panel"
          feature={feature}
          onClose={onClose}
        />
      </Box>
    </Modal>
  );
};

export default FullAccessModal;
